import * as filters from "./ngFilters";

const FiltersObj = {};

// init methods in the form xxxFilter()
Object.keys(filters).forEach((key) => {
    const res = /^(\w*)Filter/.exec(key);
    if (res && res[1]) {
        FiltersObj[res[1]] = filters[key];
    }
});

export function getFilter(name) {
    return FiltersObj[name];
}
